import { Col, Form, InputNumber, Modal, Row } from "antd";
import TextArea from "antd/es/input/TextArea";

type ModalReservaProps = {
  isModalOpen: boolean;
  handleFechar: () => void;
  onCreate: (values: any) => void;
};

export default function ModalReserva({
  isModalOpen,
  handleFechar,
  onCreate,
}: ModalReservaProps) {
  const [form] = Form.useForm();

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleFechar}
      title="Reserva"
      okText="Reservar"
      cancelText="Cancelar"
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values); // envia para o index
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
      }}
    >
      <Form form={form} layout="vertical">
        <Row>
          <Col span={16}>
            <Form.Item
              name="valorMin"
              label="Valor que Alugou"
              rules={[
                { required: true, message: "Por favor insira um valor!" },
              ]}
            >
              <InputNumber
                placeholder="Digite o valor"
                formatter={(value) => {
                  if (value === undefined || value === null) return "";
                  return `R$ ${Number(value).toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`;
                }}
                parser={(value) => {
                  if (!value) return "";
                  const onlyNumbers = value.replace(/\D+/g, ""); // Remove tudo que não for número
                  const parsedValue = (parseFloat(onlyNumbers) / 100).toFixed(
                    2
                  ); // Converte para decimal
                  return isNaN(Number(parsedValue)) ? "" : parsedValue;
                }}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
